import { Ga4Info } from './Ga4Info'
export * from './Ga4EventType'

export const ga4Info = new Ga4Info()
